import { render, staticRenderFns } from "./RootContiRicaviView.vue?vue&type=template&id=6ebdaa7e&"
import script from "./RootContiRicaviView.vue?vue&type=script&lang=ts&"
export * from "./RootContiRicaviView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports